import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';
import { isFetchingFeatureFlags } from '@core/selectors/classroom';
import React from 'react';
import useCustomZendeskItems from '@app/hooks/useCustomZendeskItems';
import OverlayLoaderPresentational from '@app/components/presentational/OverlayLoader';

import DefaultUserBar from './UserBar';
import UserBarResponsive from './UserBarResponsive';
import Zendesk from '../Zendesk/Zendesk';
import Intercom from '../Intercom/Intercom';

const UserBar = (props) => {
  const { showCustomItems } = useCustomZendeskItems();

  const { webAppFtResponsiveNavBar20254 } = useFlags();
  const fetchingFeatureFlags = useSelector(isFetchingFeatureFlags);

  // Check if flags are actually ready by looking at the flag value
  const isFlagValueReady = typeof webAppFtResponsiveNavBar20254 === 'boolean';
  const isFlagsLoading = fetchingFeatureFlags || !isFlagValueReady;
  if (isFlagsLoading) return <OverlayLoaderPresentational open />;

  return (
    <>
      {webAppFtResponsiveNavBar20254 ? (
        <UserBarResponsive {...props} />
      ) : (
        <DefaultUserBar {...props} />
      )}

      <div style={{ visibility: 'hidden' }}>
        {!('Cypress' in window && window.Cypress) && (
          <>
            <Zendesk suppressContactForm={showCustomItems} />
            <Intercom />
          </>
        )}
      </div>
    </>
  );
};

export default UserBar;
